module.exports = __webpack_public_path__ + "img/gb9123_35.prt.d014e77c.jpg";